<template>
  <div>
    <!-- Table Data -->
    <div>
      <vs-table
        id="service-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="serviceFilteredCount"
        :max-items="length"
        :data="serviceRecords"
      >
        <template slot="header">
          <!-- Per Page Record -->
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (serviceFilteredCount && 1)) || 0 }}
                      -
                      {{ serviceFilteredCount - page * length > 0 ? page * length : serviceFilteredCount }}
                      of {{ serviceTotal || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
          </div>
        </template>

        <!-- Table Header -->
        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>Service Name</vs-th>
          <vs-th>Service Detail</vs-th>
          <vs-th>User Name</vs-th>
          <vs-th>Mobile No</vs-th>
          <vs-th>Date & Time</vs-th>
        </template>

        <!-- Table Data Display -->
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <span>{{ (tr.service && tr.service.service_name) || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ tr.message || '-' }}</p>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ tr.user && tr.user.first_name }} {{ tr.user && tr.user.last_name }}</p>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ tr.user && tr.user.mobile_number }}</p>
            </vs-td>
            <vs-td class="text-left">
              <p class="capitalize">{{ formatLocalDateTime(tr.date) }}</p>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <!-- Custom Pagination -->
      <vs-pagination v-if="serviceFilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-8"></vs-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'

export default {
  name: 'service-List',

  mixins: [dateMixins],
  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Service',
    breadcrumb: []
  }),

  /** Import State */
  computed: {
    ...mapState('gurudwara', ['serviceRecords', 'serviceTotal', 'serviceFilteredCount', 'serviceListLoading']),
    /** Page Number Show Logic ( Dynamic ) */
    totalPages() {
      return Math.ceil(this.serviceFilteredCount / this.length)
    }
  },

  /** CTA functions */
  methods: {
    /** API Import */
    ...mapActions('gurudwara', {
      get: 'getServices'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Gurudwara List API */
    getData() {
      this.get({
        // order: this.order,
        gurudwara: this.$route.params.id,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    }
  },

  /** Watchers */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    serviceListLoading() {
      if (this.serviceListLoading) {
        this.$vs.loading({
          container: '#service-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#service-list > .con-vs-loading')
      }
    },
    /** Page Loading when data retrive ( API Based ) */
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  async mounted() {
    this.getData()
    const gurudwaraId = this.$route.params.id

    if (gurudwaraId) {
      await this.$store.dispatch('gurudwara/show', gurudwaraId).then(async (res) => {
        const data = res.data.data
        this.breadcrumb = [
          { title: 'Dashboard', url: '/dashboard' },
          { title: 'Gurudwara', url: '/gurudwara/list' },
          { title: data.name, url: `/gurudwara/${gurudwaraId}/service-req-list` },
          { title: 'Services', active: true }
        ]
      })
    }
  }
}
</script>
